export const COLOR_SPINNER = '#000';
export const SPINNER_DEFAULT = 'three-bounce';
export const TYPE_SPINNER = [
  'three-bounce',
  'circle',
  'double-bounce',
  'ball-clip-rotate',
  'wandering-cubes',
  'chasing-dots',
  'cube-grid',
  'wordpress',
  'folding-cube',
  'ball-triangle-path',
  'ball-pulse-sync'
];
